import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StatisticsConfig, Partner, EngineStatisticsService } from '@tj/tj-dmp-lib-api';
import { ChartComponent } from 'ng-apexcharts';
import { Parameter } from './parameter/parameter.interface';


@Component({
    selector: 'dmp-statistics-configurable-graph',
    templateUrl: './statistics-configurable-graph.component.html',
    styleUrls: ['./statistics-configurable-graph.component.scss'],
    standalone: false
})
export class StatisticsConfigurableGraphComponent implements OnInit, OnChanges {
  @ViewChild("chart") chart: ChartComponent;
  @Input() codeTenant: string;
  @Input() config: StatisticsConfig;
  @Input() partners: Array<Partner> = [];
  public chartOptions: any;
  public data: Map<string, number> = new Map<string, number>();
  public parameters: Array<Parameter> = [];
  public parametersConfig: Map<string, string> = new Map<string, string>();
  /* parameter one can be any value from 1 to 10 */


  constructor(private readonly translate: TranslateService,
              private readonly engineStatisticsService: EngineStatisticsService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
   }

  initChart(): void {
    this.chartOptions = {
      series: [
        {
          data: []
        }
      ],
      chart: {
        height: 350,
        type: "bar"
      },
      plotOptions: {
        bar: {
          dataLabels: {
            position: "top" // top, center, bottom
          }
        }
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#304758"]
        }
      },

      xaxis: {
        categories: [
        ],
        position: "bottom",

        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        crosshairs: {
          fill: {
            type: "gchartradient",
            gradient: {
              colorFrom: "#D8E3F0",
              colorTo: "#BED1E6",
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5
            }
          }
        },
        tooltip: {
          enabled: true,
          offsetY: -35
        }
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          shadeIntensity: 0.25,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [50, 0, 100, 100]
        }
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        labels: {
          show: false,
          formatter: function(val) {
            return val;
          }
        }
      }
    };
  } 

  ngOnChanges(): void {
    this.initChart();
    this.parameters.push({name: "Nombre de réservations", code: "param1", defaultValue: "2", values: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]});
    this.parameters.push({name: "Intervalle de temps en mois", code: "param2", defaultValue: "3", values: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]});
    for (const parameter of this.parameters) {
      this.parametersConfig.set(parameter.code, parameter.defaultValue);
    }
    this.getData(this.paramsToJson());
    this.changeDetectorRef.detectChanges();
  }

  public dateToIsoString(date: Date) {
    return date.toISOString().split('T')[0];
  }

  public updateChart() {
    this.chart.updateSeries(this.chartOptions.series);
    this.chart.updateOptions(this.chartOptions, false, true, true);
  }

  public emptyChart() {
    this.chartOptions.series[0].data = [];
    this.chartOptions.xaxis.categories = [];
    this.updateChart();
  }


  public async getData(params: any) {
    const resultDataStatisticsDto = await this.engineStatisticsService.getDataUsingPOST(this.codeTenant, this.config.code, null, this.partners.map(p=>p.code) ,null, params).toPromise();
    for (let i = 0; i < resultDataStatisticsDto.series[0].data.length; i++) {
      this.chartOptions.series[0].data.push(resultDataStatisticsDto.series[0].data[i][1]);
      this.chartOptions.xaxis.categories.push(resultDataStatisticsDto.series[0].data[i][0]);
    }
    console.log(resultDataStatisticsDto.series[0].data);
    this.chartOptions.series[0].name = resultDataStatisticsDto.series[0].label;
    this.updateChart();
  }

  public paramsToJson() {
    const params = {};
    for (const parameter of this.parameters) {
      params[parameter.code] = this.parametersConfig.get(parameter.code);
    }
    return params;
  }

  public selectParameter(parameterToUpdate: {parameter: string, value: string}) {
    this.parametersConfig.set(parameterToUpdate.parameter, parameterToUpdate.value);
    this.emptyChart();
    this.getData(this.paramsToJson());
  }

  ngOnInit(): void {
    
  }


}
